import { ContentType } from '@amzn/awscat-pattern-library-service-model';
import { FinalizingGraphState, ScoreBarometerSegmentType } from '../../model/Enum';

export const finalizingStateGraphColors = new Map<FinalizingGraphState, string>([
  [FinalizingGraphState.Unassigned, '#EAEDED'],
  [FinalizingGraphState.Assigned, '#AAB7B8'],
  [FinalizingGraphState.Finalizing, '#527FFF'],
  [FinalizingGraphState.Finalized, '#2E27AD'],
  [FinalizingGraphState.Distributed, '#16BF9F'],
]);

export const contentTypeColors = new Map<ContentType, string>([
  [ContentType.Pattern, '#527FFF'],
  [ContentType.Guide, '#2E27AD'],
  [ContentType.Strategy, '#16BF9F'],
]);

export const barometerSegmentColors = new Map<ScoreBarometerSegmentType, string>([
  [ScoreBarometerSegmentType.Low, '#FF4D4D'],
  [ScoreBarometerSegmentType.LowZero, '#FFCCCC'],
  [ScoreBarometerSegmentType.Med, '#FF9933'],
  [ScoreBarometerSegmentType.MedZero, '#FFE6CC'],
  [ScoreBarometerSegmentType.Hi, '#16BF9F'],
  [ScoreBarometerSegmentType.HiZero, '#D1FAF2'],
]);
